@if (sections.length === 0) {
<div class="p-3 text-gray-500">Nejsou dostupné žádné zprávy</div>
} @if (sections.length > 0) {
<div class="ml-8 mt-2 border-l-2 border-gray-300">
  <div
    class="px-2 py-1 my-2 inline-block rounded-lg -ml-4 bg-white border border-gray shadow-[0_0_0_2px_rgba(255,255,255,1.0)]"
  >
    {{ 'personal_content.coop.total_message_count' | transloco : { value: messages.length } }}
  </div>
  @for (section of sections; track section) {
  <div>
    <div
      class="px-2 py-1 my-2 inline-block rounded-lg -ml-4 bg-accent-a100 text-accent-a100-contrast shadow-[0_0_0_2px_rgba(255,255,255,1.0)]"
    >
      {{ section.date }}
    </div>
    @for (message of section.messages; track message) {
    <div [ngClass]="['flex', compact ? 'py-1' : 'py-3']">
      <div
        [title]="
          (hasEventIcon(message.structured.event)
            ? 'personal_content.coop.events.' + message.structured.event
            : 'personal_content.coop.events.unknown'
          ) | transloco
        "
        class="-ml-4 w-32 h-32 basis-[32px] shrink-0 grow-0 rounded-full z-10 shadow-[0_0_0_6px_rgba(255,255,255,1.0)] bg-gray-100 text-primary flex justify-center items-center"
      >
        <mat-icon>{{ getEventIcon(message.structured.event) }}</mat-icon>
      </div>
      @if (!compact) {
      <div class="flex flex-col gap-1">
        <div
          [title]="'personal_content.coop.priorities.' + message.structured.priority | transloco"
          class="w-32 h-32 rounded-full bg-gray-100 text-primary flex justify-center items-center"
        >
          <mat-icon [ngClass]="getPriorityColorClass(message.structured.priority)">warning </mat-icon>
        </div>
        <div
          [title]="'personal_content.coop.origins.' + message.structured.origin | transloco"
          class="w-32 h-32 rounded-full bg-gray-100 text-primary flex justify-center items-center"
        >
          <mat-icon class="text-gray-500">{{ getOriginIcon(message.structured.origin) }}</mat-icon>
        </div>
      </div>
      }
      <div [ngClass]="[compact ? 'px-2' : 'px-4', 'flex gap-4']">
        <div class="flex flex-col">
          <div class="flex gap-3">
            <div class="text-xs text-gray-500 flex gap-1">
              {{ message.structured.datetime | date : 'dd.MM.yyyy HH:mm' }}
            </div>
          </div>
          <div class="flex flex-wrap gap-1">
            <!--<span>{{message.structured.datetime | date: 'HH:mm:ss'}}</span>-->
            <!-- eslint-disable-next-line -->
            <div
              (click)="sendMessageToUser.emit(message.structured.sender.id)"
              class="flex gap-1 items-center cursor-pointer"
            >
              @if (message.structured.sender.avatar) {
              <img
                [alt]="message.structured.sender.name + ' avatar'"
                [src]="message.structured.sender.avatar"
                class="rounded-full h-16 w-16"
              />
              }
              <span class="text-primary underline">{{ message.structured.sender.name }}</span>
            </div>
            <span>{{ getText(message.structured.text) }}</span>
            @if (message.structured.event === 'collectionCreate' || message.structured.event === 'collectionDisseminate'
            || message.structured.event === 'collectionDisseminateManifest') { @if
            (message.structured?.collection?.primary) {
            <!-- eslint-disable-next-line -->
            <span
              (click)="onRouteToCollection(message.structured.collection.primary)"
              [ngClass]="[
                'text-accent italic',
                hasLink(message.structured.collection.primary) ? 'underline cursor-pointer' : ''
              ]"
              >{{ message.structured.collection.primary.label }}</span
            >
            } } @if (message.structured.event === 'nibbleCreate' || message.structured.event === 'nibbleCopy') {
            <span class="text-accent">{{ message.structured?.nibble?.label || '' }}</span>
            <span>{{ 'personal_content.coop.in_collection' | transloco }}</span>
            @if (message.structured?.collection?.primary) {
            <!-- eslint-disable-next-line -->
            <span
              (click)="onRouteToCollection(message.structured.collection.primary)"
              [ngClass]="[
                'text-accent italic',
                hasLink(message.structured.collection.primary) ? 'underline cursor-pointer' : ''
              ]"
              >{{ message.structured.collection.primary.label }}</span
            >
            } @for (collection of message.structured.collection?.secondary || []; track collection; let last = $last) {
            <!-- eslint-disable-next-line -->
            <span
              (click)="onRouteToCollection(collection)"
              [ngClass]="['text-accent italic', hasLink(collection) ? 'underline cursor-pointer' : '']"
              >{{ collection.label }} @if (!last) { , }</span
            >
            } } @if (message.structured.event === 'nibbleUpdate') {
            <span class="text-accent">{{ message.structured.nibble?.label || '' }}</span>
            } @if (message.structured.event === 'collectionUpdate') { @if (message.structured?.collection?.primary) {
            <!-- eslint-disable-next-line -->
            <span
              (click)="onRouteToCollection(message.structured.collection.primary)"
              [ngClass]="[
                'text-accent italic',
                hasLink(message.structured.collection.primary) ? 'underline cursor-pointer' : ''
              ]"
              >{{ message.structured.collection.primary.label }}</span
            >
            }
            <span>{{ getText(message.structured.additional) }}</span>
            } @if (message.structured.event === 'collectionCoopOpen' || message.structured.event ===
            'collectionCoopClose' || message.structured.event === 'collectionCoopJoin' || message.structured.event ===
            'personalMessageSend') { @if (message.structured?.collection?.primary) {
            <!-- eslint-disable-next-line -->
            <span
              (click)="onRouteToCollection(message.structured.collection.primary)"
              [ngClass]="[
                'text-accent italic',
                hasLink(message.structured.collection.primary) ? 'underline cursor-pointer' : ''
              ]"
              >{{ message.structured.collection.primary.label }}</span
            >
            } }
          </div>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>
}
